var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["gift-card/product-gift-card-calendar.j2"] = require( "gift-card/product-gift-card-calendar.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/gift-card/product-gift-card-deliveryDate.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "product/templates/gift-card/product-gift-card-deliveryDate.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_4 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_4);
if(t_1.hasOwnProperty("hasErrors")) {
var t_5 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_5);
if(t_1.hasOwnProperty("validatedDatePickerField")) {
var t_6 = t_1.validatedDatePickerField;
} else {
cb(new Error("cannot import 'validatedDatePickerField'")); return;
}
context.setVariable("validatedDatePickerField", t_6);
output += "<div class=\"c-form__field u-clearfix ";
output += runtime.suppressValue((lineno = 3, colno = 47, runtime.callWrap(t_5, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"validation")),"messages")),"deliveryDate")])), env.opts.autoescape);
output += " is-required\">\n\n\t<label class=\"c-form__label\" for=\"delivery-date\">";
output += runtime.suppressValue((lineno = 5, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_gift-card-delivery"])), env.opts.autoescape);
output += "</label>\n\n\t<div class=\"o-row o-column o-extra-small--12 js-date-picker-calendar\">\n\n\t\t<div class=\"o-column o-extra-small--6 o-small--7 o-large--5 u-no-gutters c-date-picker__field js-date-picker-outer\">\n\n\t\t\t<input\n                readonly\n                required type=\"text\"\n                id=\"delivery-date\"\n                name=\"deliveryDate\"\n                class=\"c-form__text js-date-picker\"\n                placeholder=\"\"\n                data-qa-deliver-date=";
output += runtime.suppressValue((lineno = 18, colno = 62, runtime.callWrap(t_6, "validatedDatePickerField", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"datetimeOptions")),"dateFormatString"),runtime.makeKeywordArgs({"isRequired": runtime.contextOrFrameLookup(context, frame, "True"),"requiredErrorCode": "REQUIRED_DELVIERY_DATE"})])), env.opts.autoescape);
output += "\n\t\t\t\taria-labelledby=\"delivery-date-hint\" aria-describedby=\"delivery-date_error\">\n            </input>\n\n            <div class=\"c-form-hint\">\n                <p id=\"delivery-date-hint\" class=\"c-form-hint__p\">\n                    ";
output += runtime.suppressValue((lineno = 24, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_gift-card-delivery-disclaimer"])), env.opts.autoescape);
output += "\n                </p>\n            </div>\n\n\t\t\t";
output += runtime.suppressValue((lineno = 28, colno = 22, runtime.callWrap(t_4, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"validation")),"messages")),"deliveryDate"),runtime.makeKeywordArgs({"id": "delivery-date"})])), env.opts.autoescape);
output += "\n\n\t\t</div>\n\n\t\t<div class=\"o-column o-extra-small--3\">\n\n\t\t\t<a class=\"c-date-picker__calendar js-calendar-icon\" data-qa-calendar-icon>";
env.getTemplate("gift-card/product-gift-card-calendar.j2", false, "product/templates/gift-card/product-gift-card-deliveryDate.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "</a>\n\n\t\t</div>\n\n\t\t<div class=\"c-date-picker__outer\">\n\n\t\t\t<div class=\"c-date-picker__inner js-delivery-date-calendar-container\" data-qa-deliver-date-calendar></div>\n\n\t\t</div>\n\n\t</div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/gift-card/product-gift-card-deliveryDate.j2"] , dependencies)